function debounce(fn, wait) {
    let timeoutId;
    return function debounced(...args) {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => fn.apply(this, args), wait);
    };
}

function refreshAosSoon() {
    if (!window.AOS || typeof window.AOS.refreshHard !== 'function') return;
    window.requestAnimationFrame(() => {
        window.AOS.refreshHard();
    });
}

function getLineHeightPx(element) {
    const styles = window.getComputedStyle(element);
    const lineHeight = parseFloat(styles.lineHeight);
    if (!Number.isNaN(lineHeight) && lineHeight > 0) return lineHeight;

    const fontSize = parseFloat(styles.fontSize);
    if (!Number.isNaN(fontSize) && fontSize > 0) return fontSize * 1.4;

    return 24; // bezpieczny fallback
}

function ensureInnerWrapper(descEl) {
    const firstChildEl = descEl.firstElementChild;
    if (firstChildEl && firstChildEl.classList.contains('offer__desc-inner')) return firstChildEl;

    const inner = document.createElement('div');
    inner.className = 'offer__desc-inner';

    while (descEl.firstChild) {
        inner.appendChild(descEl.firstChild);
    }

    descEl.appendChild(inner);
    return inner;
}

function createButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'offer__readmore';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Czytaj więcej';
    return button;
}

function updateMeasurements(descEl, innerEl, lines) {
    const lineHeight = getLineHeightPx(descEl);
    const collapsedHeight = Math.round(lineHeight * lines);

    // scrollHeight bywa 0 jeśli element jest display:none; w ofercie raczej nie występuje,
    // ale zabezpieczamy się na przyszłość.
    const expandedHeight = Math.max(innerEl.scrollHeight, innerEl.getBoundingClientRect().height);

    descEl.dataset.collapsedHeight = String(collapsedHeight);
    descEl.dataset.expandedHeight = String(Math.ceil(expandedHeight));

    return { collapsedHeight, expandedHeight };
}

function applyState(descEl, buttonEl, isExpanded) {
    const collapsedHeight = Number(descEl.dataset.collapsedHeight || 0);
    const expandedHeight = Number(descEl.dataset.expandedHeight || 0);

    if (isExpanded) {
        descEl.classList.add('is-expanded');
        descEl.style.maxHeight = expandedHeight ? `${expandedHeight}px` : '';
        buttonEl.textContent = 'Zwiń';
        buttonEl.setAttribute('aria-expanded', 'true');
    } else {
        descEl.classList.remove('is-expanded');
        descEl.style.maxHeight = collapsedHeight ? `${collapsedHeight}px` : '';
        buttonEl.textContent = 'Czytaj więcej';
        buttonEl.setAttribute('aria-expanded', 'false');
    }
}

function setupOfferReadMore({ selector = '.offer__item .desc', lines = 10 } = {}) {
    const descList = document.querySelectorAll(selector);
    if (!descList.length) return;

    const instances = [];

    descList.forEach(descEl => {
        // Nie dubluj jeśli skrypt odpali się drugi raz
        if (descEl.dataset.readmoreReady === '1') return;

        // Upewnij się, że element może animować wysokość
        descEl.classList.add('offer__desc');

        const innerEl = ensureInnerWrapper(descEl);
        const { collapsedHeight } = updateMeasurements(descEl, innerEl, lines);

        // Jeśli mieści się w 10 liniach, nic nie robimy
        if (innerEl.scrollHeight <= collapsedHeight + 1) {
            descEl.dataset.readmoreReady = '1';
            return;
        }

        const buttonEl = createButton();
        descEl.insertAdjacentElement('afterend', buttonEl);

        // Stan początkowy: zwinięty
        applyState(descEl, buttonEl, false);

        buttonEl.addEventListener('click', () => {
            const nextExpanded = !descEl.classList.contains('is-expanded');

            // Przed rozwinięciem/zwinieciem odśwież pomiar (np. po zmianie fontów/łamania)
            updateMeasurements(descEl, innerEl, lines);
            applyState(descEl, buttonEl, nextExpanded);

            refreshAosSoon();
        });

        descEl.dataset.readmoreReady = '1';
        instances.push({ descEl, innerEl, buttonEl, lines });
    });

    if (!instances.length) return;

    // Po pierwszym zwinięciu opisów layout się zmienia — odśwież AOS,
    // żeby punkty wyzwolenia dla kolejnych sekcji były poprawne.
    refreshAosSoon();

    const onResize = debounce(() => {
        instances.forEach(({ descEl, innerEl, buttonEl, lines }) => {
            const wasExpanded = descEl.classList.contains('is-expanded');
            updateMeasurements(descEl, innerEl, lines);
            applyState(descEl, buttonEl, wasExpanded);
        });

        refreshAosSoon();
    }, 150);

    window.addEventListener('resize', onResize, { passive: true });
}

document.addEventListener('DOMContentLoaded', () => {
    setupOfferReadMore();
});
